// externals
import type { MouseEvent } from 'react';
import { useDispatch } from 'react-redux';

// libraries
import { IconButton } from '@interstate/components/IconButton';
import { UserCircleIcon } from '@interstate/components/Icons';

// actions
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';

export const CustomerInsightsTrigger = () => {
    const dispatch = useDispatch();

    const openCustomerInsights = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        dispatch(baseDealActionCreators.setCustomerInsightsSlideoutStatus(true));
    };

    return (
        <IconButton
            data-testid="customer-insights-trigger"
            aria-label="Open customer insights"
            size="sm"
            buttonStyle="tertiary"
            onClick={openCustomerInsights}
        >
            <UserCircleIcon />
        </IconButton>
    );
};

export default CustomerInsightsTrigger;
